// Shopify injects the consent banner and preferences dialog itself, so their markup can't be edited in the theme.
(() => {
  // Swap the Privacy Policy link for the "Manage preferences" button, relabelled as "read more"
  const replacePolicyLink = () => {
    const policyLink = document.getElementById('shopify-pc__banner__body-policy-link');
    const manageButton = document.getElementById('shopify-pc__banner__btn-manage-prefs');
    if (!policyLink || !manageButton) return;

    // Drop the "Learn more in our" lead-in that precedes the link, keeping the sentences before it
    const leadIn = policyLink.previousSibling;
    if (leadIn?.nodeType === Node.TEXT_NODE) {
      const sentenceEnd = leadIn.textContent.lastIndexOf('.');
      if (sentenceEnd !== -1) leadIn.textContent = `${leadIn.textContent.slice(0, sentenceEnd + 1)} `;
    }

    const label = manageButton.querySelector('span') || manageButton;
    label.textContent = window.cookieBannerStrings?.readMore || 'read more';
    manageButton.classList.add('shopify-pc__banner__btn-read-more');
    policyLink.replaceWith(manageButton);
  };

  const enhancePreferencesDialog = () => {
    const dialog = document.getElementById('shopify-pc__prefs__dialog');
    if (!dialog || dialog.dataset.enhanced) return;
    dialog.dataset.enhanced = 'true';

    const title = document.getElementById('shopify-pc__prefs__header-title');
    if (title && window.cookieBannerStrings?.preferencesTitle) title.textContent = window.cookieBannerStrings.preferencesTitle;

    // Use the banner's shorter "accept" / "decline" labels instead of "Accept all" / "Decline all"
    const bannerAccept = document.getElementById('shopify-pc__banner__btn-accept')?.textContent.trim();
    const bannerDecline = document.getElementById('shopify-pc__banner__btn-decline')?.textContent.trim();
    ['shopify-pc__prefs__header-accept', 'shopify-pc__prefs__header-save'].forEach((id) => {
      const button = document.getElementById(id);
      if (button && bannerAccept) button.textContent = bannerAccept;
    });
    const declineButton = document.getElementById('shopify-pc__prefs__header-decline');
    if (declineButton && bannerDecline) declineButton.textContent = bannerDecline;

    const essentialLabel = dialog.querySelector('#shopify-pc__prefs__essential label');
    if (essentialLabel) {
      const alwaysOn = document.createElement('span');
      alwaysOn.className = 'shopify-pc__prefs__always-on';
      alwaysOn.textContent = window.cookieBannerStrings?.alwaysOn || 'Always on';
      essentialLabel.append(alwaysOn);
    }

    // "accept" accepts everything until the visitor has made (or already had) their own choices, then it saves those
    const optionalInputs = dialog.querySelectorAll('.shopify-pc__prefs__option input:not(#shopify-pc__prefs__essential-input)');
    if ([...optionalInputs].some((input) => input.checked)) dialog.classList.add('has-choices');
    optionalInputs.forEach((input) => {
      input.addEventListener('change', () => dialog.classList.add('has-choices'));
    });
  };

  const enhance = () => {
    replacePolicyLink();
    enhancePreferencesDialog();
  };

  enhance();
  new MutationObserver(enhance).observe(document.body, { childList: true, subtree: true });
})();
